import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

// Send cookies with every request (cookie-based auth)
axios.defaults.withCredentials = true;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(false);

  // Check maintenance status
  useEffect(() => {
    axios.get('/api/maintenance/status')
      .then(r => setMaintenance(r.data.maintenance))
      .catch(() => setMaintenance(false));
  }, []);

  // Restore session from httpOnly cookie (server validates it)
  useEffect(() => {
    axios.get('/api/auth/me')
      .then(r => setUser(r.data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await axios.post('/api/auth/login', { email, password });
    setUser(r.data.user);
    return r.data;
  };

  const logout = async () => {
    try { await axios.post('/api/auth/logout'); } catch (e) {}
    setUser(null);
  };

  const register = async (data) => {
    const r = await axios.post('/api/auth/register', data);
    setUser(r.data.user);
    return r.data;
  };

  const updateUser = (updates) => setUser(u => ({ ...u, ...updates }));

  // Show maintenance page for non-admins
  if (maintenance && (!user || user.role !== 'admin') && !loading) {
    return (
      <AuthContext.Provider value={{ user, loading, maintenance, setMaintenance, login, logout, register, updateUser }}>
        {children}
      </AuthContext.Provider>
    );
  }

  return (
    <AuthContext.Provider value={{ user, loading, maintenance, setMaintenance, login, logout, register, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}
